export default "__VITE_ASSET__Yyd4E6WV__"